module.exports = __webpack_public_path__ + "images/emoji/cry.c3c4d70c119d7b38c66b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cry.png
// module id = 1qeN
// module chunks = 13